import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import { Container, Header, Icon, Anchor, Button } from 'Components/core';

import InfoBox from 'Components/InfoBox';
import ReadyToEnroll from 'Views/benefits/components/ReadyToEnroll';

// Images
import LifeInsurance from './images/Life_and_Disability_-_Life_insurance.jpeg';
import ShortTerm from './images/Life_and_Disability_-_Short-term_disability.jpeg';
import LongTerm from './images/Life_and_Disability_-_Long-term_disability.jpeg';

import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import Api from 'Root/libs/analytics/Api';
import CODES from 'Root/libs/analytics/CodeDef';
import { replaceAnchor } from 'Root/libs/anchor';
import { HeaderV2, SubHeader, TitleHeader } from 'Components/core/Header';
import PaddedContainer from 'Components/core/PaddedContainer';
import ResourceLeftImage from './images/ResourceAdvisorLeft.svg';

export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_LND);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        return (
          <Container column maxWidth style={{ margin: 'auto' }}>
            <HeaderV2 title={'Life And Disability'}></HeaderV2>
            <PaddedContainer column>
              <CardContainer>
                {state.lifeAndDisability?.lifeInsurance && (
                  <React.Fragment>
                    <Card header="Life insurance" image={LifeInsurance}>
                      {state.lifeAndDisability?.lifeInsurance !== true && (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: replaceAnchor(
                              state.lifeAndDisability?.lifeInsurance
                            )
                          }}
                        ></p>
                      )}
                      {state.lifeAndDisability?.lifeInsurance === true && (
                        <React.Fragment>
                          <p>
                            Life insurance is designed to pay benefits should
                            something happen to you. But we go beyond just
                            sending a benefit check. You’ll have access to:
                          </p>
                          <ul>
                            <li>
                              <b>Resource Advisor</b> can help you right now at
                              no extra cost. You can get help to create a will,
                              establish a budget and financial plan, cope with
                              identity theft, manage a legal issue, or get
                              personal counseling. Grief counseling, legal and
                              financial advice, and other guidance are also
                              available to your family for six months if
                              anything should happen to you.
                            </li>
                            <li>
                              <b>Travel assistance</b> gives you access to
                              emergency medical and travel services if you’re
                              traveling more than 100 miles from home.
                            </li>
                            <li>
                              <b>Living benefits</b> allow you to get part of
                              your life insurance benefits early if you’re
                              terminally ill. Your beneficiary may get an extra
                              benefit if your death or certain injuries are
                              caused by an accident.
                            </li>
                            <li>
                              <b>Beneficiary support</b> can help your survivors
                              settle your estate and handle other matters when
                              you pass away. Plus, your beneficiaries can
                              contact your Resource Advisor for grief
                              counseling, legal and financial advice, and other
                              guidance for six months should anything happen to
                              you.
                            </li>
                          </ul>
                        </React.Fragment>
                      )}
                    </Card>
                  </React.Fragment>
                )}
                {state.lifeAndDisability?.shortDisability && (
                  <Card header="Short-term disability" image={ShortTerm}>
                    {state.lifeAndDisability?.shortDisability !== true && (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: replaceAnchor(
                            state.lifeAndDisability?.shortDisability
                          )
                        }}
                      ></p>
                    )}
                    {state.lifeAndDisability?.shortDisability === true && (
                      <p>
                        If you’re not able to work because of a certain accident
                        or illness, short-term disability benefits can help give
                        you the financial backup you need. We help you get back
                        to work — and back to your life — with face-to-face and
                        telephone counseling and other support services.
                      </p>
                    )}
                  </Card>
                )}
                {state.lifeAndDisability?.longDisability && (
                  <Card header="Long-term disability" image={LongTerm}>
                    {state.lifeAndDisability?.longDisability !== true && (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: replaceAnchor(
                            state.lifeAndDisability?.longDisability
                          )
                        }}
                      ></p>
                    )}
                    {state.lifeAndDisability?.longDisability === true && (
                      <p>
                        If a lengthy illness or injury keeps you from work for
                        an extended period of time, long-term disability
                        benefits can give you peace of mind. We provide services
                        to help you get back to work and improve your health,
                        including behavioral health counseling, legal services
                        and financial advice.
                      </p>
                    )}
                  </Card>
                )}
              </CardContainer>
            </PaddedContainer>

            {state.lifeAndDisability?.resourceAdvisor && (
              <ResourceAdvisor
                text={state.lifeAndDisability?.resourceAdvisor}
              ></ResourceAdvisor>
            )}
          </Container>
        );
      }}
    </Subscribe>
  );
};

const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  margin-top: 60px;
  flex-wrap: wrap;
`;

const CardDiv = styled.div`
  width: 456px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  margin-bottom: 30px;
  > img {
    border-radius: 8px 8px 0px 0px;
  }
`;

const CardHeader = styled.div`
  font-family: 'Elevance Sans Regular';
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  text-align: left;
  color: #333;
  padding: 20px;
  padding-bottom: 0px;
`;

const CardText = styled.div`
  font-family: 'Elevance Sans Regular';
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: left;
  color: #131331;
  padding: 20px;
  padding-top: 0px;
`;

const Card = ({ header, children, image }) => {
  return (
    <CardDiv>
      <img src={image}></img>
      <CardHeader> {header}</CardHeader>
      <CardText> {children} </CardText>
    </CardDiv>
  );
};

const ResourceAdvisorContainer = styled.div`
  background: #f2695a;
  display: flex;
  padding: 60px;
  padding-bottom: 120px;
  flex-wrap: wrap;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    padding: 10px;
  }
`;

const ResourceAdvisorRight = styled.div`
  flex: 3;
`;
const ResourceAdvisorLeft = styled.div`
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ResourceAdvBenefitsCard = styled.div`
  background: #fff;

  border-radius: 8px;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  margin-top: 30px;
  width: 100%;

  font-family: 'Elevance Sans regular';
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: left;
  color: #131331;

  > b {
    font-family: 'Elevance Sans semiBold';
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    text-align: left;
    color: #333;
  }
`;

const ResourceAdvisorCardHolder = styled.div`
  max-width: 552px;
`;

const ResourceAdvImage = styled.img`
  width: 287px;
  height: auto;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: 50vw%;
    height: auto;
  }
`;

const ResourceAdvisor = ({ text }) => {
  return (
    <ResourceAdvisorContainer>
      <ResourceAdvisorLeft>
        <ResourceAdvImage src={ResourceLeftImage} />
      </ResourceAdvisorLeft>
      <ResourceAdvisorRight>
        <ResourceAdvisorCardHolder>
          <TitleHeader style={{ textAlign: 'center', display: 'block' }}>
            Resource Advisor
          </TitleHeader>

          <ResourceAdvBenefitsCard
            dangerouslySetInnerHTML={{
              __html: replaceAnchor(text)
            }}
          ></ResourceAdvBenefitsCard>
        </ResourceAdvisorCardHolder>
      </ResourceAdvisorRight>
    </ResourceAdvisorContainer>
  );
};
